import { Link } from "react-router-dom";
import { CATEGORIES } from "@/data/calculators";
import { Activity } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border/70 bg-secondary/30" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 grid gap-10 md:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Activity className="h-4 w-4" />
            </span>
            <span className="font-bold text-lg tracking-tight">
              Fitness<span className="text-muted-foreground font-medium">Calculator</span>
            </span>
          </Link>
          <p className="mt-3 text-sm text-muted-foreground max-w-xs">
            32 free, fast and accurate health & fitness calculators — all in one clean place.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold mb-3">Categories</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            {CATEGORIES.filter((c) => c.id !== "all").map((c) => (
              <li key={c.id}>
                <Link to={`/?cat=${c.id}`} className="hover:text-foreground">
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold mb-3">Site</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/about" className="hover:text-foreground">About</Link></li>
            <li><Link to="/contact" className="hover:text-foreground">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-foreground">Disclaimer</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold mb-3">Note</h4>
          <p className="text-sm text-muted-foreground">
            Results are estimates for informational purposes and not medical advice. Always consult a qualified healthcare professional.
          </p>
        </div>
      </div>
      <div className="border-t border-border/70">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Fitness Calculator. All rights reserved.</p>
          <p className="text-xs text-muted-foreground">Built for speed, accuracy and clarity.</p>
        </div>
      </div>
    </footer>
  );
}
